import ListContainer from './ListContainer';

const PageList = () => {
  return (
    <div
      className="flex flex-col items-start space-y-1 relative h-[calc(100vh-300px)]"
      style={{ overflowY: 'auto' }}
    >
      <ListContainer />
    </div>
  );
};

export default PageList;
